import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, PhoneIcon, MapPinIcon, FacebookIcon, InstagramIcon, TwitterIcon, YoutubeIcon } from 'lucide-react';
import { Input } from '../ui/Input';
import { Button } from '../ui/Button';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-300" data-id="element-274">
      {/* Newsletter section */}
      <div className="bg-primary-600" data-id="element-275">
        <div className="max-w-7xl mx-auto px-4 py-8" data-id="element-276">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-277">
            <div data-id="element-278">
              <h3 className="text-xl font-bold text-white" data-id="element-279">
                Subscribe to our Newsletter
              </h3>
              <p className="text-primary-100" data-id="element-280">
                Get the latest deals and updates delivered to your inbox
              </p>
            </div>
            <div className="flex w-full md:w-auto gap-2" data-id="element-281">
              <Input type="email" placeholder="Enter your email" className="bg-white/10 border-white/20 text-white placeholder:text-white/60 w-full md:w-80" data-id="element-282" />
              <Button variant="secondary" className="whitespace-nowrap" data-id="element-283">
                Subscribe
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-4 py-12" data-id="element-284">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-285">
          {/* Company info */}
          <div data-id="element-286">
            <div className="flex items-center gap-2 mb-4" data-id="element-287">
              <img src="https://cdn.magicpatterns.com/uploads/fRsBpVfPoCHsQawYgHjccg/ChatGPT_Image_Mar_6,_2026,_03_48_02_AM.png" alt="Gadgets Zone" className="h-10 w-auto object-contain bg-white rounded p-1" data-id="element-288" />
              <div data-id="element-289">
                <h2 className="text-lg font-bold text-white" data-id="element-290">Gadgets Zone</h2>
              </div>
            </div>
            <p className="text-sm mb-4" data-id="element-291">
              Your one-stop shop for affordable gadgets and electronics. Quality
              products at the best prices in Pakistan.
            </p>
            <div className="space-y-2 text-sm" data-id="element-292">
              <div className="flex items-center gap-2" data-id="element-293">
                <MapPinIcon className="w-4 h-4 text-primary-400" data-id="element-294" />
                <span data-id="element-295">Karachi, Pakistan</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-296">
                <PhoneIcon className="w-4 h-4 text-primary-400" data-id="element-297" />
                <span data-id="element-298">+92-313-2370605</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-299">
                <MailIcon className="w-4 h-4 text-primary-400" data-id="element-300" />
                <span data-id="element-301">waqas.nizam@paysyslabs.com</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-302">
            <h3 className="text-white font-semibold mb-4" data-id="element-303">Quick Links</h3>
            <ul className="space-y-2 text-sm" data-id="element-304">
              <li data-id="element-305">
                <Link to="/products" className="hover:text-primary-400 transition-colors" data-id="element-306">
                  All Products
                </Link>
              </li>
              <li data-id="element-307">
                <Link to="/products?deals=true" className="hover:text-primary-400 transition-colors" data-id="element-308">
                  Deals & Offers
                </Link>
              </li>
              <li data-id="element-309">
                <Link to="/products?new=true" className="hover:text-primary-400 transition-colors" data-id="element-310">
                  New Arrivals
                </Link>
              </li>
              <li data-id="element-311">
                <Link to="/products?bestseller=true" className="hover:text-primary-400 transition-colors" data-id="element-312">
                  Best Sellers
                </Link>
              </li>
              <li data-id="element-313">
                <Link to="/about" className="hover:text-primary-400 transition-colors" data-id="element-314">
                  About Us
                </Link>
              </li>
              <li data-id="element-315">
                <Link to="/contact" className="hover:text-primary-400 transition-colors" data-id="element-316">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div data-id="element-317">
            <h3 className="text-white font-semibold mb-4" data-id="element-318">Customer Service</h3>
            <ul className="space-y-2 text-sm" data-id="element-319">
              <li data-id="element-320">
                <Link to="/account" className="hover:text-primary-400 transition-colors" data-id="element-321">
                  My Account
                </Link>
              </li>
              <li data-id="element-322">
                <Link to="/account/orders" className="hover:text-primary-400 transition-colors" data-id="element-323">
                  Order History
                </Link>
              </li>
              <li data-id="element-324">
                <Link to="/track-order" className="hover:text-primary-400 transition-colors" data-id="element-325">
                  Track Order
                </Link>
              </li>
              <li data-id="element-326">
                <Link to="/wishlist" className="hover:text-primary-400 transition-colors" data-id="element-327">
                  Wishlist
                </Link>
              </li>
              <li data-id="element-328">
                <Link to="/faq" className="hover:text-primary-400 transition-colors" data-id="element-329">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Policies */}
          <div data-id="element-330">
            <h3 className="text-white font-semibold mb-4" data-id="element-331">Policies</h3>
            <ul className="space-y-2 text-sm" data-id="element-332">
              <li data-id="element-333">
                <Link to="/privacy-policy" className="hover:text-primary-400 transition-colors" data-id="element-334">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-335">
                <Link to="/terms" className="hover:text-primary-400 transition-colors" data-id="element-336">
                  Terms & Conditions
                </Link>
              </li>
              <li data-id="element-337">
                <Link to="/return-policy" className="hover:text-primary-400 transition-colors" data-id="element-338">
                  Return & Refund Policy
                </Link>
              </li>
              <li data-id="element-339">
                <Link to="/shipping-policy" className="hover:text-primary-400 transition-colors" data-id="element-340">
                  Shipping Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Social links & payment methods */}
        <div className="mt-12 pt-8 border-t border-gray-800" data-id="element-341">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-342">
            <div className="flex items-center gap-4" data-id="element-343">
              <span className="text-sm" data-id="element-344">Follow us:</span>
              <div className="flex items-center gap-3" data-id="element-345">
                <a href="#" className="w-8 h-8 bg-gray-800 rounded-full flex items-center justify-center hover:bg-primary-600 transition-colors" aria-label="Facebook" data-id="element-346">
                  <FacebookIcon className="w-4 h-4" data-id="element-347" />
                </a>
                <a href="#" className="w-8 h-8 bg-gray-800 rounded-full flex items-center justify-center hover:bg-primary-600 transition-colors" aria-label="Instagram" data-id="element-348">
                  <InstagramIcon className="w-4 h-4" data-id="element-349" />
                </a>
                <a href="#" className="w-8 h-8 bg-gray-800 rounded-full flex items-center justify-center hover:bg-primary-600 transition-colors" aria-label="Twitter" data-id="element-350">
                  <TwitterIcon className="w-4 h-4" data-id="element-351" />
                </a>
                <a href="#" className="w-8 h-8 bg-gray-800 rounded-full flex items-center justify-center hover:bg-primary-600 transition-colors" aria-label="YouTube" data-id="element-352">
                  <YoutubeIcon className="w-4 h-4" data-id="element-353" />
                </a>
              </div>
            </div>
            <div className="flex items-center gap-4" data-id="element-354">
              <span className="text-sm" data-id="element-355">We accept:</span>
              <div className="flex items-center gap-2" data-id="element-356">
                <div className="bg-white rounded px-2 py-1 text-xs font-bold text-gray-900" data-id="element-357">
                  VISA
                </div>
                <div className="bg-white rounded px-2 py-1 text-xs font-bold text-gray-900" data-id="element-358">
                  MC
                </div>
                <div className="bg-white rounded px-2 py-1 text-xs font-bold text-green-600" data-id="element-359">
                  JazzCash
                </div>
                <div className="bg-white rounded px-2 py-1 text-xs font-bold text-blue-600" data-id="element-360">
                  EasyPaisa
                </div>
                <div className="bg-gray-700 rounded px-2 py-1 text-xs font-bold text-white" data-id="element-361">
                  COD
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="bg-gray-950 py-4" data-id="element-362">
        <div className="max-w-7xl mx-auto px-4 text-center text-sm" data-id="element-363">
          <p data-id="element-364">© 2024 Gadgets Zone. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}